import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { captureReferralFromUrl, claimStoredReferral } from "@/lib/referral";

/**
 * Remembers a `?ref=CODE` visit and attaches it to the account once the visitor
 * signs in. The reward itself is paid out server-side after a confirmed purchase.
 */
export function ReferralCapture() {
  const { search } = useLocation();

  useEffect(() => {
    captureReferralFromUrl(search);
  }, [search]);

  useEffect(() => {
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) void claimStoredReferral();
    });
    supabase.auth.getSession().then(({ data }) => {
      if (data.session?.user) void claimStoredReferral();
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  return null;
}
